import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import i18n from 'live/services/i18n'

export default function Importing (){
    return (
        <Modal.Dialog dialogClassName="modal-loading">
            <Modal.Header>
                <Modal.Title>{i18n('Importing')}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {i18n('Importing spreadsheet data...')}
                
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-primary" disabled>
                    <i className="far fa-spinner fa-spin" />
                </button>
            </Modal.Footer>
        </Modal.Dialog>
    )
}
